// Shared colour palette (owner's 9 shop colours) for Studio + product page.
export const COLOUR_OPTIONS = [
  { name: "Pink", hex: "#F472B6" },
  { name: "Blue", hex: "#60A5FA" },
  { name: "Green", hex: "#4ADE80" },
  { name: "Brown", hex: "#8B5E3C" },
  { name: "White", hex: "#FFFFFF" },
  { name: "Red", hex: "#EF4444" },
  { name: "Yellow", hex: "#FACC15" },
  { name: "Black", hex: "#1E1926" },
  { name: "Gray", hex: "#9CA3AF" },
];

export const COLOUR_HEX = Object.fromEntries(
  COLOUR_OPTIONS.map((c) => [c.name.toLowerCase(), c.hex])
);
